<template>
  <Layout>
      
    <!-- TODO properties should be dynamically passed with :props="getProps(componentName)" -->
    <component v-for="(componentName, index) in componentOrder" :key="index" :is="componentName"  
    
      :pageTitle='selectedSpecialGroup ? selectedSpecialGroup.name : null' 
      :subtitle1="selectedSpecialGroup ? selectedSpecialGroup.description1 : null" 
      :subtitle2="selectedSpecialGroup ? selectedSpecialGroup.description2 : null"

      :video="selectedSpecialGroup.video"

      :newItems="selectedSpecialGroup ? selectedSpecialGroup.slidingItems : null" />


    <!-- <BannerVideo/>
    <ProductsSlider/>
    <Shop/> -->








  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import Banner from "@/components/banner.vue"
import BannerVideo from "@/components/banner-video.vue"
import ProductsSlider from "@/components/products-slider.vue"
import Shop from "@/components/shopComponent.vue"
import SpecialGroupApi from "@/services/specialGroup-api";



export default ({
    name: "Catalogue",

    components: {
      Layout, Banner, BannerVideo, ProductsSlider, Shop
    },

    props: {

    },


    watch :{
        '$route': {
              immediate: true,
              deep: true, 
              handler(route) {

                  const specialGroupSeoName = route.params.specialgroup;
                  const selectedSectionName  = route.params.section;

                  if (specialGroupSeoName) {
                    this.getSpecialGroupBySeoName(specialGroupSeoName, selectedSectionName);
                  }
              }
          },
    },


  mounted() {
   
  },

  computed: {
      componentOrder() {
        if (!this.selectedSpecialGroup) {
          return [];
        }

        let cpms = [];

        const addComponent = (component, priority) => {
            if (component != null) {
                cpms.push({ name: component, priority: priority });
            }
        };

        // Add components with priority if not null
        if (this.selectedSpecialGroup.banner) {
          addComponent('Banner', this.selectedSpecialGroup?.bannerPriority);
        }

        if (this.selectedSpecialGroup.video) {
          addComponent('BannerVideo', this.selectedSpecialGroup?.videoPriority);
        }
       
        if (this.selectedSpecialGroup.slidingItems) {
          addComponent('ProductsSlider', this.selectedSpecialGroup?.slidingItemsPriority);
        }
        
        addComponent('Shop', this.selectedSpecialGroup?.itemsPriority);
        
        
       

        // Sort the components based on priority
        cpms.sort((a, b) => (a.priority || Infinity) - (b.priority || Infinity));

        // Extract only the names of the components in the sorted order
        return cpms.map(component => component.name);

           // ['Banner', 'ProductsSlider', 'Shop', 'BannerVideo'],
        }
    },

  data() {
    return {
      selectedSpecialGroup: null,
    }
  },

  methods: {
    getProps(componentName) {
      switch (componentName) {
        case 'Banner':
          return {
            pageTitle: "Nouvelle Collection",
            subtitle1: "Un style chic pour tous les jours, qui n'a jamais ",
            subtitle2: "osé rêver de ça tous les jours ?"
          };
        default:
          return {};
      }
    }, 

    getSpecialGroupBySeoName(seoname, selectedSectionName){

      if (!seoname) {
        return;
      }

      SpecialGroupApi.getSpecialGroupBySeoName(seoname, selectedSectionName)
      .then(result => {
        if(result){
          this.selectedSpecialGroup = result;
        }
      })
    },
  
  } 
});
</script>

<style scoped>
</style>



